import { render } from "./form-email.vue?vue&type=template&id=3804aa9a"
import script from "./form-email.js?vue&type=script&lang=js&external"
export * from "./form-email.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__